import React, { useRef, useEffect, useState, useCallback } from "react";
import Form from "react-bootstrap/Form";

function NumericFormControl({ defaultValue, ...props }) {
  const [value, setValue] = useState(defaultValue);
  const lastValidValueRef = useRef(props.value || props.defaultValue);
  const formControlRef = useRef();
  const handleKeyDown = useCallback(e => {
    // prevent input other than numbers, periods, and commas.
    if (e.key.length === 1 && !e.altKey && !e.metaKey && !e.ctrlKey) {
      if (!/[0-9,.]/.test(e.key)) {
        e.preventDefault();
      }
    }
  }, []);
  const { min, max, onChange, onBlur } = props;
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = useCallback(e => {
    setIsFocused(true);
  }, []);
  const handleBlur = useCallback(e => {
    setIsFocused(false);
    let txt = e.target;
    if (!txt.checkValidity()) {
      let numericVal = parseFloat(txt.value);
      if (isNaN(numericVal)) {
        numericVal = lastValidValueRef.current;
      } else {
        // update the value to the max or min that the entered value has gone beyond:
        if ((min ?? null) !== null) numericVal = Math.max(numericVal, min);
        if ((max ?? null) !== null) numericVal = Math.min(numericVal, max);
      }
      txt.value = numericVal;
      if (lastValidValueRef.current !== numericVal) {
        lastValidValueRef.current = numericVal;
        onChange?.(numericVal);
      }
    }
    onBlur?.(e);
  }, [max, min, onBlur, onChange]);
  const handleChange = useCallback(e => {
    let txt = e.target,
      val = txt.value,
      numericVal = parseFloat(val);
    setValue(val);
    if (txt.checkValidity()) {
      lastValidValueRef.current = numericVal;
      onChange?.(numericVal);
    }
  }, [onChange]);
  useEffect(() => {
    if (!isFocused) {
      setValue(defaultValue);
    }
  }, [defaultValue, isFocused]);

  return (
    <Form.Control
      ref={formControlRef}
      {...props}
      value={value}
      type="number"
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  );
}

export default NumericFormControl;
